export default {
  title: {
    weChatTemplateMessageManagementTitle: '微信模板消息管理'
  },
  label: {
    weChatAccountIdLabel: '微信公众号开发者ID (AppID)',
    weChatAccountKeyLabel: '微信公众号开发者密码 (AppKey)',
    weChatAccountTokenLabel: '微信公众号服务器令牌 (Token)',
    weChatAccountPasswordLabel: '微信公众号服务器消息加解密密钥 (EncodingAESKey)',
    weChatWebhook: '微信公众号服务器回调地址 (URL)',
    weChatAccountUrl: '微信公众号链接',
    weChatAccountUrlTip: '可联系菁客协助配置',
    weChatTemplateMessageTitle: '微信模板消息',
    weChatTemplateMessageStatus: '状态',
    createOrEditTemplateTitle: '填入下方信息创建/编辑微信模板消息。',
    createOrEditTemplateIdLabel: '模板ID',
    createOrEditTemplateContentTitle: '您可以在开头和结尾信息内输入以下动态占位符：',
    createOrEditTemplateFieldTitle: '{{ Candidate Name }}，{{ Company Name }}，{{ Job Name }}',
    createOrEditTemplateFieldContent: '内容',
    createOrEditTemplatePreview: '内容预览',
    selectTemplateField: '点击按钮添加微信模版参数',
    inputCustomField: '微信参数值。例如，thing3',
    customTemplateTypeFieldLabel: '请输入内容',
    customTemplateTypeFieldValue: '自定义：',
    verifyFile: '微信JS接口安全域名验证文件'
  },
  placeholder: {
    verifyFile: '请选择文件'
  },
  btn: {
    selectFile: '选择文件'
  },
  tip: {
    appIdError: 'App ID 不能为空！',
    appSecretError: 'AppKey 不能为空！',
    createOrUpdateAppAccount: '绑定微信公众号',
    mustNeedTemplateId: '必须填写模板ID',
    invalidAppId: '请检查',
    invalidAppSecret: '请检查'
  },
  message: {
    confirmCreateAppAccountTitle: '确定要绑定该微信公众号吗？',
    confirmUpdateAppAccountTitle: '确定要更改绑定的微信公众号吗？更改公众号将会删除用户与原公众号的绑定信息，并且微信消息模板将会失效，需要重新配置。',
    updateAppAccountSuccess: '更新微信账号信息成功',
    createAppAccountSuccess: '创建微信账号信息成功',
    invalidAppId: '无效的微信账号信息，请检查 App ID 和 AppKey',
    verifyFileSize: '选择的文件大小不能超过{size}KB'
  }
}
